import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { classes } from 'typestyle';

import { Formatters, Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { ViewTooltip } from '~src/views/components/ViewTooltip';
import { IViewInfo } from '~src/views/models/IViewInfo';

import { PopularExplanation, ShortExplanation, SimiliarUsersExplanation } from '../../models/IViewRecommendationInfo';

const popoverTriggerLabelId = 'why-is-this-recommended';
export class RecommendationCard extends ContentCard {

  public render() {
    const {
      content, urls, hovered, selected, allowDragAndDrop, addContentFavorite, removeContentFavorite
    } = this.props;
    return (
      <div className={classes(
        CardViewStyles.Card,
        CardViewStyles.RecommendationCard,
        selected && CardViewStyles.SelectedRecommendationCard
      )}>
        {this.renderRecommendationExplanation()}
        <Thumbnail navigateUrl={getContentUrlForItem(content, urls)}
          defaultImageUrl={imgPath('spaces_card_view.svg')}
          thumbnailImageUrl={content.thumbnailUrl}
          hovered={hovered}
          selected={selected}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
          contentType={content.contentType}
        />
        <div className={CardViewStyles.ActionRow} style={{...this.getCardZoomStyleForActionRow(), marginBottom: '-3px'}}>
          <CardTitle name={content.name} data-tb-test-id="rec-item-name" />
          {this.renderViewsCountForVizRec()}
          <span>
            <FavoriteToggle isTabbable={true}
              isFavorite={content.favorite}
              itemName={content.name}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'view' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'view' })} />
          </span>
          {this.renderFavoritesCountForVizRec()}
          {this.renderActionsMenu()}
        </div>
        <div data-tb-test-id="more-info-section" className={CardViewStyles.CardDescription} style={{display: 'flex', alignItems: 'center'}}>
          <span style={{paddingRight: TabStyles.Spacing.SmallSpace}}>
            <CardPopoverWidget
              buttonLabelId={popoverTriggerLabelId}
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.viewTooltipTitle()}
            />
          </span>
          <span id={popoverTriggerLabelId} className={CardViewStyles.ElideText}>
            {Messages.vizRecommendationsExplanationBase()}
          </span>
        </div>
      </div>
    );
  }

  private renderViewsCountForVizRec = () => {
    const viewsCount = (this.props.content as IViewInfo).usageInfo.hitsTotal;
    if (Number.isInteger(viewsCount)) {
      return (
        <React.Fragment>
          <img src={imgPath('spaces_card_views.svg')} alt={Messages.viewIconTooltip()} className={CardViewStyles.VizRecViewsIcon} />
          <span className={CardViewStyles.VizRecViewsCount}>{Formatters.formatCountInRecommendationCard(viewsCount)}</span>
        </React.Fragment>
      );
    }
  };

  private renderFavoritesCountForVizRec = () => {
    const favoritesCount = (this.props.content as IViewInfo).usageInfo.favoritesTotal;
    if (Number.isInteger(favoritesCount)) {
      const favoritesLabel = `${Messages.favoritesTotal()} ${Formatters.formatCountInRecommendationCard(favoritesCount)}`;
      return <span className={CardViewStyles.VizRecFavoritesCount} role="img" aria-label={favoritesLabel}>{Formatters.formatCountInRecommendationCard(favoritesCount)}</span>;
    }
  };

  private renderRecommendationExplanation = () => {
    let explanationShape: string = '';
    let explanationText = '';
    let textClassName = CardViewStyles.RecommendationCardText;
    let shapeClassName = CardViewStyles.RecommendationCardShape;

    if (this.props.content.explanationType === PopularExplanation) {
      explanationText = Messages.vizRecommendationsPopularExplanation();
      if (explanationText.length <= ShortExplanation) {
        explanationShape = 'ribbon_Trending.svg';
      } else {
        explanationShape = 'ribbon_Trending_Long.svg';
        shapeClassName = CardViewStyles.RecommendationCardMidShape;
        textClassName = CardViewStyles.RecommendationCardLongText;
      }
    } else if (this.props.content.explanationType === SimiliarUsersExplanation) {
      explanationText = Messages.vizRecommendationsSimiliarUsersExplanation();
      if (explanationText.length <= ShortExplanation) {
        explanationShape = 'ribbon_ForYou.svg';
      } else {
        explanationShape = 'ribbon_ForYou_Long.svg';
        shapeClassName = CardViewStyles.RecommendationCardForYouShapeLong;
      }
    }

    if (explanationShape && explanationText) {
      return <div data-tb-test-id="recommendation-explanation" className={CardViewStyles.RecommendationExplanation}>
        <span className={textClassName}>{explanationText}</span>
        <img src={imgPath(explanationShape)}
          alt=""
          className={shapeClassName} />
      </div>;
    }
  };

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return ViewTooltip;
  }
}
